module.exports = __webpack_public_path__ + "static/media/qualiassist.81aeefbf.png";